import {useListView} from '../../core/ListViewProvider'
import {HawalasListToolbar} from './HawalaListToolbar'
import {HawalasListGrouping} from './HawalasListGrouping'
import {HawalasListSearchComponent} from './HawalasListSearchComponent'

const HawalasListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header bhawala-0 pt-6'>
      <HawalasListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <HawalasListGrouping /> : <HawalasListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {HawalasListHeader}
